module.exports = __webpack_public_path__ + "img/logs.e201add4.png";